import { render, staticRenderFns } from "./cost_tpl.vue?vue&type=template&id=10bec330&scoped=true&"
import script from "./cost_tpl.vue?vue&type=script&lang=js&"
export * from "./cost_tpl.vue?vue&type=script&lang=js&"
import style0 from "./cost_tpl.vue?vue&type=style&index=0&id=10bec330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bec330",
  null
  
)

export default component.exports